import "core-js/modules/es.array.push.js";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import moment from "moment";
import { iconColor } from "@/consts/iconColor";
const __default__ = {
  name: "LatestAttendanceCounter",
  filters: {
    mmdd: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.slice(5);
    }
  },
  data: () => ({
    summary: []
  }),
  computed: { ...mapState(["classrooms"])
  },

  created() {
    this.setData(); // 毎分更新

    this.intervalId = setInterval(() => this.setData(), 1000 * 60 * 3);
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },

  methods: {
    iconColor,

    async setData() {
      const data = await getData("reader/get_assigned_class_attendance_summary").catch(error => {
        console.log(error);
      });

      if (!data || !data.items) {
        return;
      }

      const classAttendanceObj = data.items;
      const today = moment().format("YYYY-MM-DD");
      this.summary = this.classrooms.filter(v => classAttendanceObj[v.id]).map(v => {
        const counterSummary = {
          attendance: {
            absence: 0,
            late: 0,
            leave: 0,
            noAttend: 0
          },
          classroom: v,
          attendanceList: [],
          absenceRate: 0
        };
        classAttendanceObj[v.id].forEach(v2 => {
          if (v2.date === today && v2.is_daily_latest) {
            // 当日分かつ最新のデータのみクラス別人数を数字で出す
            const type = v2.type.split("-")[0];

            switch (type) {
              case "欠席":
                counterSummary.attendance.absence += 1;
                break;

              case "遅刻":
                counterSummary.attendance.late += 1;
                break;

              case "早退":
                counterSummary.attendance.leave += 1;
                break;

              case "遅刻早退":
                counterSummary.attendance.late += 1;
                counterSummary.attendance.leave += 1;
                break;

              case "未登校":
                counterSummary.attendance.noAttend += 1;
                break;
            }
          }

          counterSummary.attendanceList.push({
            id: v2.id,
            date: moment(v2.date).format("YYYY年MM月DD日"),
            createdAt: moment(v2.created_at).format("MM月DD日 HH時mm分"),
            updatedAt: v2.updated_at,
            studentName: v2.student.name ? v2.student.name.replace(/\s+/, " ") : "",
            studentId: v2.student_id,
            type: v2.type,
            guardianMemo: v2.guardian_memo,
            comment: v2.comment,
            isDeleted: !v2.is_daily_latest
          });
        });
        counterSummary.attendanceList = counterSummary.attendanceList.sort((a, b) => a.updatedAt < b.updatedAt ? 1 : -1);
        counterSummary.attendanceList.forEach(v => {
          v.isHistory = Boolean(v.isDeleted && counterSummary.attendanceList.filter(v2 => v.studentId === v2.studentId && v.date === v2.date).length > 1);
        });
        const attendance = [];
        counterSummary.attendanceList.forEach(v => {
          const historyStudentArray = attendance.find(v2 => v2[0].studentId === v.studentId && v2[0].date === v.date);

          if (historyStudentArray) {
            historyStudentArray.push(v);
          } else {
            attendance.push([v]);
          }
        });

        if (counterSummary.attendance.absence > 0 && v.students_count > 0) {
          counterSummary.absenceRate = (counterSummary.attendance.absence / v.students_count * 100).toFixed(1);
        }

        return counterSummary;
      });
    }

  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // import { inject } from "vue";
    // const attendanceMode = inject("attendanceMode");
    // const changeAttendanceMode = () => {
    //   attendanceMode.value = "info";
    // };
    return {
      __sfc: true,
      iconColor
    };
  }

});